<template>
  <div class="col-md-12" id="waiverSigned">
    <v-row>
      <v-col cols="8">
        <h1 class="text-left mb-0" style="color:black;"> {{$t("waiver_signed.title")}}</h1> <br />
      </v-col>
    </v-row>
    <br />

    <v-row>
      <v-col cols="12" md="6">
        <v-autocomplete 
          :items="events" v-model="eventSelect" item-text="name" item-value="id" dense outlined clearable
          :label="$t('waiver_signed.select')" return-object @change="selectEvent" class="selectSeries"
          :no-data-text="$t('common.no_data')"
        >
          <template v-slot:item="{ item }">
                      <div v-html="item.name"></div>
          </template>
          <template v-slot:selection="{ item }">
                      <div v-html="item.name"></div>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" >
        <v-btn @click="exportToCSV">{{ $t('waiver_signed.export_to_csv')}}</v-btn>
      </v-col>
      <v-col class="contentRespTableFilter" cols="12">
        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="filteredItems"
          :items-per-page="-1"
          dense
          item-key="id"
          hide-default-header
          row
          ref="dataTableRef"
          :footer-props="{
            'items-per-page-text': $t('dataTable.rowsPerPageText'),
            'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
          }"  
          :no-data-text="$t('common.no_data')"
          :headerProps="{
            'sort-by-text': $t('dataTable.sortByText')
          }"
          :no-results-text="$t('dataTable.no_matching_records')"
        >
          <template v-slot:header="{ props: { headers } }">
            <thead class="headTable">
              <tr>
                <th v-for="h in headers" :key="h.text" @click="sortableCustom(h.value)" style="cursor: pointer">{{
                  h.text }}</th>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td><v-text-field class="my-2" hide-details outlined dense v-model="firstNameFilterValue" type="text"
                    :label="$t('waiver_signed.first_name')"></v-text-field></td>
                <td><v-text-field class="my-2" hide-details outlined dense v-model="lastNameFilterValue" type="text"
                    :label="$t('waiver_signed.last_name')"></v-text-field></td>
                <td><v-text-field class="my-2" hide-details outlined dense v-model="dateSignedFilterValue" type="text"
                    :label="$t('waiver_signed.date_signed')"></v-text-field></td>
                <td><v-text-field class="my-2" hide-details outlined dense v-model="ageFilterValue"
                    onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'"
                    type="number" min="1" :label="$t('waiver_signed.age')"></v-text-field></td>
                <td>
                  <v-select 
                    class="my-2 classFilter" 
                    v-model="statusFilterValue" 
                    :items="waiverStatus" 
                    outlined multiple dense
                    :return-object="false"
                    :label="$t('waiver_signed.status')"
                    :no-data-text="$t('common.no_data')"
                  >
                    <template v-slot:selection="{ item, index }">
                      <v-chip v-if="index === 0">
                            <span>{{ item.text }}</span>
                      </v-chip>
                      <span v-if="index === 1" class="grey--text caption">
                        (+{{ statusFilterValue.length - 1 }} {{ $t("waiver_signed.others") }})
                      </span>
                    </template>
                  </v-select>
                </td>
                <td><v-text-field class="my-2" hide-details outlined dense v-model="signedByFilterValue" type="text"
                    :label="$t('waiver_signed.signed_by')"></v-text-field></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </thead>
            <thead class="headTableMobile">
              <tr>
                <td><v-text-field class="my-2" hide-details outlined dense v-model="filterValue" type="text"
                    :label="$t('common.search')"></v-text-field></td>
              </tr>
            </thead>
          </template>
          <template v-slot:[`item.registered`]="{ item }">
            <tr>
              <td>{{ $t(`waiver_signed.is_${item.registered}`) }}</td>
            </tr>
          </template>
          <template v-slot:[`item.hasValidWaiver`]="{ item }">
            <tr>
              <td>{{ $t(`waiver_signed.has_valid_waiver_${item.hasValidWaiver}`) }}</td>
            </tr>
          </template>
          <template v-slot:[`item.waiverStatus`]="{ item }">
            <tr>
              <td>{{ $t(`waiver_signed.waiver_status_${item.waiverStatus || 'Missing'}`) }}</td>
            </tr>
          </template>
          <template v-slot:[`item.view`]="{ item }">
            <v-icon small class="mr-2" @click="openWarning(item)">fa far
              fa-eye
            </v-icon>
          </template>
          <template v-slot:[`item.pdf`]="{ item }">
            <v-icon v-if="item.waiverStatus=='Signed'" small class="mr-2" @click="getPdf(item)">fa-file-pdf</v-icon>
          </template>
          <template v-slot:[`item.hasSignatoryPicture`]="{ item }">
            <v-btn v-if="item.hasSignatoryPicture" icon @click="getWaiverPicture(item.ewsId)"><v-icon>fa-duotone
                fa-image</v-icon></v-btn>
            <v-btn v-else icon disabled><v-icon>fa-solid fa-ban</v-icon></v-btn>
          </template>
          <template v-slot:[`item.reject`]="{ item }">
            <v-icon v-if="item.waiverStatus=='Signed'" small class="mr-2" @click="confirmDelete(item)">fas
              fa-trash-alt</v-icon>
            <v-icon v-if="item.hasValidWaiver=='invalid'" small class="mr-2" @click="confirmEmailWaiver(item)">fas
              fa-envelope</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="openWar" width="550">
      <v-card>
        <v-card-title>
          <span class="headLine">{{ $t("waiver_signed.title-confirmed") }}</span>
        </v-card-title>
        <v-card-text>
          <p style="text-align: justify;">
            {{ $t("waiver_signed.text-confirmed-1") }} <br />
            {{ $t("waiver_signed.text-confirmed-2") }}
          </p>
        </v-card-text>
        <v-card-actions class="confirmedOpenRsp">
          <v-spacer></v-spacer>
          <v-btn color="darken-1" dark small class="btn btn_xs_rsp mt-sm-0 mt-1" @click="view(itemConfirmed)">
            {{ $t("waiver_signed.open-new-tab") }}
          </v-btn>
          <v-btn color="darken-1" dark small class="btn_xs_rsp mt-sm-0 mt-1" text @click="openWar = false">
            {{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogWaiverPicture" width="250">
      <v-card class="text-right" :loading="loadingSignatoryPicture">
        <v-spacer></v-spacer>
        <v-btn icon @click="closeWaiverPicture()">
            <v-icon>far fa-window-close</v-icon>
          </v-btn>
        <v-img
          :src="signatoryImage"
          class="white--text align-end" gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
        </v-img>
      </v-card>
          <div class="text-center" style="background-color:#bbb; text-align: center !important; padding: 5px !important; margin: 0px;">
            {{ currentItem.signatoryName }}, {{ currentItem.signatoryLastname }}
          </div>
    </v-dialog>
    <v-snackbar v-model="snack" :color="color_snack">{{ msg_snack }}</v-snackbar>
    <v-dialog v-model="dialogMinorEmailWaiver" width="550">
      <v-card>
        <v-card-title>
          <span class="headLine">{{ $t("waiver_signed.email_minor_title") }}</span>
        </v-card-title>
        <v-card-text>
          <p v-if="minorAccountManagers.length === 0">
            {{ $t("waiver_signed.email_minor_no_account_manager") }}
          </p>
          <template v-else>
            <p>{{ $t("waiver_signed.email_minor_select_account_manager") }}</p>
            <v-select
              v-model="selectedAccountManagerId"
              :items="minorAccountManagers"
              item-text="name"
              item-value="id"
              outlined
              dense
              :label="$t('waiver_signed.account_manager')"
              :no-data-text="$t('common.no_data')"
            ></v-select>
            <p v-if="minorEmailWaiverConfirmationMessage">
              {{ minorEmailWaiverConfirmationMessage }}
            </p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" dark small text @click="closeEmailWaiverDialogs">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            v-if="minorAccountManagers.length > 0"
            color="darken-1"
            dark
            small
            :disabled="!selectedAccountManagerId"
            @click="sendEmailWaiver"
          >
            {{ $t("waiver_signed.send_email") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SGSNotificationConfirm v-if="dialogNotification" :notificationMessage="$t('waiver_signed.confirmation_message')"
      @cancel="dialogNotification=false;" @agree="UpdateItem" type='warning' />
    <SGSNotificationConfirm v-if="dialogEmailWaiver" :notificationMessage="emailWaiverConfirmationMessage"
      @cancel="dialogEmailWaiver=false;" @agree="sendEmailWaiver" type='warning' />
  </div>
</template>

<script>
import { apiCalls } from "@/mixins/apiCalls.js";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";

const NON_SORTABLE_COLUMNS = ["reject", "view", "pdf", "hasSignatoryPicture"];

export default {
  name:"Signed",
  components: {SGSNotificationConfirm},
  mixins: [apiCalls],
  data(){
    return{
      buttonColor: "#000",
      singleSelect: false,
      selected: [],
      events:[],
      eventSelect:'',
      msg_snack: '',
      snack: false,
      color_snack: 'success',
      search: '',
      userCurrent: null,
      dialogNotification: false,
      dialogEmailWaiver: false,
      dialogMinorEmailWaiver: false,
      item: null,
      emailWaiverItem: null,
      selectedAccountManagerId: null,
      waivers :[],
      dialog: false,
      tab: null,
      emergencyInformation:[],
      Name: '',
      openWar: false,
      itemConfirmed: null,
      firstNameFilterValue: "",
      lastNameFilterValue: "",
      dateSignedFilterValue: "",
      ageFilterValue: "",
      statusFilterValue: "",
      signedByFilterValue: "",
      filterValue: "",
      sortBy: 'isAgreedChk',
      sortDesc: true, 
      windowWidth: 0,
      itemsStatus: ["Signed","NotSigned","Rejected", "Missing"],
      dialogWaiverPicture: false,
      oadingSignatoryPicture: false,
      ewsId: null,
      signatoryImage: null,
      loadingSignatoryPicture: false
    }
  },
  methods:{
    /**
     * Fetches the signatory image for the specified waiver ID and updates the component state.
     *
     * This function sets loading states, opens the dialog, and retrieves the signatory's image.
     * If the response is successful, it updates the `signatoryImage` property.
     *
     * @param {string|number} ewsId - The unique identifier for the waiver's signatory.
     */
    async getWaiverPicture(ewsId) {
        // Validate ewsId
        if (!ewsId || (typeof ewsId !== 'string' && typeof ewsId !== 'number')) return;

        // Start loading and open dialog
        this.loadingSignatoryPicture = true;
        this.dialogWaiverPicture = true;
        this.ewsId = ewsId;

        try {
            // Fetch the signatory image from the API
            const response = await this.api("get", `/api/v1/promoter/event/waivers/signatoryImage/${ewsId}`);

            // Return early if the response is unsuccessful
            if (!response || response.success !== 1) return;

            // Set the signatory image and stop loading
            this.signatoryImage = response.message;
            
        } catch (error) {
            // Optional: Set an error flag if needed for UI feedback
            this.apiError = true;
        } finally {
            // Stop loading in all cases
            this.loadingSignatoryPicture = false;
        }
    },

    closeWaiverPicture()
    {
      this.dialogWaiverPicture = false;
      this.loadingSignatoryPicture = false;
      this.ewsId = null;
      this.signatoryImage = null;
    },
    openWarning(item) {
        this.openWar = true;
        this.itemConfirmed = item;
    },
    /**
     * Opens the PDF waiver link in a new tab for the specified item.
     *
     * This function checks if a `waiverLink` exists in the item, extracts the last segment of the link,
     * and opens the PDF in a new browser tab.
     *
     * @param {Object} item The item object containing the waiver link.
     */
    getPdf(item) {
        // Return early if there is no waiverLink in the item
        if (!item.waiverLink) return;

        // Extract the last segment of the link
        const linkSegments = item.waiverLink.split('/');
        const linkId = linkSegments[linkSegments.length - 1];

        // Open the PDF link in a new browser tab
        window.open(`${process.env.VUE_APP_ROOT}/laravel/public/api/v1/livelaps/promoter/waiver/getpdfwaiver/${linkId}`, '_blank');
    },

    /**
     * Opens the specified waiver link in a new tab and closes the warning dialog.
     *
     * This function opens the waiver link associated with the provided item in a new browser tab.
     * It also sets `openWar` to false to close any related dialog or warning.
     *
     * @param {Object} item The item object containing the waiver link.
     */
    async view(item) {
        // Return early if waiverLink is missing or empty in the item
        if (!item || !item.waiverLink) return;

        // Open the waiver link in a new browser tab
        window.open(`${process.env.VUE_APP_ROOT}/livelaps${item.waiverLink}`, '_blank');

        // Close the warning dialog or reset the state
        this.openWar = false;
    },

    confirmDelete(item){
        this.item = item;
        this.dialogNotification = true;
    },
    confirmEmailWaiver(item){
        this.emailWaiverItem = item;
        if (item.isMinor || item.ageTarget === "Minor") {
            const managers = item.accountManagers || [];
            this.selectedAccountManagerId = managers.length === 1 ? managers[0].id : null;
            this.dialogMinorEmailWaiver = true;
            return;
        }
        this.dialogEmailWaiver = true;
    },
    closeEmailWaiverDialogs() {
        this.dialogEmailWaiver = false;
        this.dialogMinorEmailWaiver = false;
        this.emailWaiverItem = null;
        this.selectedAccountManagerId = null;
    },
    async sendEmailWaiver() {
        if (!this.emailWaiverItem) return;
        if ((this.emailWaiverItem.isMinor || this.emailWaiverItem.ageTarget === "Minor") && !this.selectedAccountManagerId) return;

        this.dialogEmailWaiver = false;
        this.dialogMinorEmailWaiver = false;

        try {
            const payload = {
                eventId: this.emailWaiverItem.eventId,
                userId: this.emailWaiverItem.userId,
                signedWaiverId: this.emailWaiverItem.ewsId,
            };
            if (this.emailWaiverItem.isMinor || this.emailWaiverItem.ageTarget === "Minor") {
                payload.accountManagerUserId = this.selectedAccountManagerId;
            }
            const response = await this.api(
                "post",
                "/api/v1/promoter/event/waivers/email",
                payload
            );

            if (response && response.success === 1) {
                this.showSnackBar(this.$t("waiver_signed.email_sent"));
                this.closeEmailWaiverDialogs();
                this.selectEvent();
                return;
            }

            const message = response && response.message && response.message.error
                ? response.message.error
                : "waiver_email_failed";
            this.showSnackBar(this.$t(`waiver_signed.${message}`), "error");
        } catch (error) {
            this.apiError = true;
            this.showSnackBar(this.$t("waiver_signed.waiver_email_failed"), "error");
        }
    },
    showSnackBar(message, color = "success") {
        this.msg_snack = message;
        this.color_snack = color;
        this.snack = true;
    },
    /**
     * Fetches the current user's information and updates the `userCurrent` property.
     *
     * This function calls the API to retrieve the current user's data and assigns it
     * to the `userCurrent` property if the response is successful.
     */
    async getUser() {
        try {
            // Fetch current user data from the API
            const getUserCurrent = await this.api("get", "/api/v1/users/current");

            // Return early if the response or message is missing
            if (!getUserCurrent || !getUserCurrent.message) return;

            // Assign the user data to `userCurrent`
            this.userCurrent = getUserCurrent.message;
        } catch (error) {
            // Optional: Handle the error if needed (e.g., setting an error state)
            this.apiError = true;  // Example: Set an error flag for UI feedback
        }
    },

    /**
     * Updates the current item by rejecting it via API call and refreshing the event if successful.
     *
     * This function checks if an item is set, then calls the API to reject the item.
     * If the rejection is successful, it triggers a refresh of the selected event.
     */
    async UpdateItem() {
        // Return early if there is no item to update
        if (!this.item) return;

        // Hide dialog notification before making the request
        this.dialogNotification = false;

        try {
            // Send the rejection request to the API
            const response = await this.api(
                "put",
                `/api/v1/promoter/event/waivers/reject/${this.item.ewsId}`
            );

            // Refresh the event if the response indicates success
            if (response.message === 1) {
                this.selectEvent();
            }
        } catch (error) {
            // Optional: handle error, set an error flag, or log if needed
            this.apiError = true;  // Example: set an error flag to handle errors in the UI
        }
    },

    /**
     * Fetches waiver events and updates the selected event.
     *
     * This function calls the API to retrieve a list of waiver events, updates the `events` array,
     * and sets the first event as the selected event if available. It also triggers `selectEvent` for further actions.
     */
    async getEvents() {
        try {
            // Fetch events from the API
            const response = await this.api("get", "/api/v1/promoter/event/waivers/getWaiverEvents");

            // Return early if the response or message is missing
            if (!response || !response.message) return;

            // Assign the events
            this.events = response.message;

            // Return early if no events are available
            if (this.events.length === 0) return;

            // Set the first event as the default selection and trigger selectEvent
            this.eventSelect = this.events[0];
            this.selectEvent();

        } catch (error) {
            // Optionally, handle the error internally or set an error state in the component if needed
            this.apiError = true;  // Example: set an error flag if you handle errors visually
        }
    },

    /**
     * Fetches the waivers for the selected event and formats the name for each waiver.
     *
     * This function retrieves the waivers associated with the currently selected event,
     * and formats each waiver's name by combining the signatory's first and last name.
     */
    async selectEvent() {
        try {
            // Ensure eventSelect is defined before making the API call
            if (!this.eventSelect || !this.eventSelect.id) return;

            // Fetch waivers for the selected event
            const response = await this.api(
                "get",
                `/api/v1/promoter/event/waivers/createdWaivers/${this.eventSelect.id}`
            );

            // Check if the response and message data are available
            if (!response || !response.message) return;

            // Assign waivers and format names
            this.waivers = response.message;
            this.waivers.forEach(waiver => {
                waiver.name = `${waiver.signatoryName} ${waiver.signatoryLastname}`;
            });
            
        } catch (error) {
            // Optional: Set an error flag or handle the error in the UI if necessary
            this.apiError = true;  // Example: setting an error flag for UI handling
        }
    },

    sortableCustom(item) {
      if(NON_SORTABLE_COLUMNS.indexOf(item) === -1){
        if(item != this.sortBy) {
          this.sortBy = item;
          this.sortDesc = false;
        } else {
          this.sortDesc = !this.sortDesc;
        }
      }
    },
    customSort(items, sortBy, sortDesc) {
      let results = items;
      if(sortBy && sortBy.length > 0 && sortDesc && sortDesc.length > 0) {
        let reA = /[^a-zA-Z]/g;
        let reN = /[^0-9]/g;
        
        if(sortBy[0] == "number") {
          results = items.sort( function (a, b) {
            var AInt = parseInt(a[sortBy[0]], 10);
            var BInt = parseInt(b[sortBy[0]], 10);

            if(isNaN(AInt) && isNaN(BInt)){
                var aA = a[sortBy[0]].replace(reA, "");
                var bA = b[sortBy[0]].replace(reA, "");
                if(aA === bA) {
                    var aN = parseInt(a[sortBy[0]].replace(reN, ""), 10);
                    var bN = parseInt(b[sortBy[0]].replace(reN, ""), 10);
                    return aN === bN ? 0 : aN > bN ? 1 : -1;
                } else {
                    return aA > bA ? 1 : -1;
                }
            }else if(isNaN(AInt)){//A is not an Int
                return 1;//to make alphanumeric sort first return -1 here
            }else if(isNaN(BInt)){//B is not an Int
                return -1;//to make alphanumeric sort first return 1 here
            }else{
                return AInt > BInt ? 1 : -1;
            }
          });
        } else {
          results = items.sort( function (x, y){
            let _x = x[sortBy[0]];
            let _y = y[sortBy[0]];
            if(sortBy[0] == "isAgreedChk") {
              _x = new Date(x[sortBy[0]]);
              _y = new Date(y[sortBy[0]]);
            } else if(sortBy[0] != "age") {
              _x = x[sortBy[0]].toString().toLowerCase();
              _y = y[sortBy[0]].toString().toLowerCase();
              _x = _x.trim();
              _y = _y.trim();
            }
            if (_x < _y) {return -1;}
            if (_x > _y) {return 1;}
            return 0;
          });
        }
        
        if(sortDesc[0]) {
          results = results.reverse();
        }
        if(sortBy[0] == "number") {
          let nullResults = results.filter((el) => { return !el.number || el.number == "" });
          let notNullResults = results.filter((el) => { return el.number && el.number != "" });
          results = notNullResults.concat(nullResults);
        }

        return results;
      }
      return items;
    },
    getCSVContent()
    {
      const headers = this.headers.filter(obj => obj.value != 'view' && obj.value != 'reject' && obj.value != 'pdf').map(header => header.value).join(',') + '\n';
      let csvContent = headers;
      
      const rows = this.filteredItems.map(row => {
        return [
            row.participantName,
            row.participantLastname,
            row.isAgreedChk,
            row.age,
            row.waiverStatus,
            row.name,
            row.registered,
            row.hasValidWaiver
        ]
      });
      
      const csvRowsContent = rows.reduce((data, row) =>
      {
        return data + row.join(',') + '\n';
      }, '');

      return csvContent + csvRowsContent;
    },
    exportToCSV()
    {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += this.getCSVContent();
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "data.csv");
      document.body.appendChild(link); // Required for Firefox
      link.click();
    },
  },
  computed:{
    waiverStatus() {
      const uniqueStatuses = [...new Set(this.waivers.map(w => w.waiverStatus || 'Missing'))];
      return uniqueStatuses.map(status => ({
        text: this.$t(`waiver_signed.waiver_status_${status}`),
        value: status
      }));
    },
    headers()
    {
      return [
        {
          text: this.$t('waiver_signed.view'),
          sortable: false,
          value: 'view',
        },
        {
          text: this.$t('waiver_signed.pdf'),
          sortable: false,
          value: 'pdf',
        },
        { text: this.$t('waiver_signed.picture'), value: 'hasSignatoryPicture', sortable: false },
        { text: this.$t('waiver_signed.first_name'), value: 'participantName', sortable: true  },
        { text: this.$t('waiver_signed.last_name'), value: 'participantLastname', sortable: true  },
        { text: this.$t('waiver_signed.date_signed'), value: 'isAgreedChk', sortable: true  },
        { text: this.$t('waiver_signed.age'), value: 'age', sortable: true  },
        { text: this.$t('waiver_signed.status'), value: 'waiverStatus', sortable: true  },
        { text: this.$t('waiver_signed.signed_by'), value: 'name', sortable: true  },
        { text: this.$t('waiver_signed.registered'), value: 'registered', sortable: true  },
        { text: this.$t('waiver_signed.has_valid_waiver'), value: 'hasValidWaiver', sortable: true  },
        {
          text: this.$t('waiver_signed.action'),
          sortable: false,
          value: 'reject',
        }
      ];
    },
    filteredItems() {
      let results = []
      if(this.waivers.length > 0) {
        results = this.waivers;
        const windowWidth = window.innerWidth;
        if(windowWidth >= 600) {
          if(
              (this.firstNameFilterValue || "").length > 0 || (this.lastNameFilterValue || "").length > 0 || 
              (this.dateSignedFilterValue || "").length > 0 || (this.ageFilterValue || "").length > 0 || 
              (this.statusFilterValue || "").length > 0 || (this.signedByFilterValue || "").length > 0
            ) {
            results = results.filter((item) => {
              return (
                (
                  (this.firstNameFilterValue || "").length == 0 || 
                  ((this.firstNameFilterValue || "").length > 0 && (item.participantName || "").toLowerCase().includes(this.firstNameFilterValue.toLowerCase()))
                ) && 
                (
                  (this.lastNameFilterValue || "").length == 0 ||
                  ((this.lastNameFilterValue || "").length > 0 && (item.participantLastname || "").toLowerCase().includes(this.lastNameFilterValue.toLowerCase()))
                ) && 
                (
                  (this.dateSignedFilterValue || "").length == 0 || 
                  (this.dateSignedFilterValue || "").length > 0 && item.isAgreedChk != null && item.isAgreedChk.toLowerCase().includes(this.dateSignedFilterValue.toLowerCase())
                ) && 
                (
                  (this.ageFilterValue ||  "").length == 0 ||
                  ((this.ageFilterValue ||  "").length > 0 && (item.age || "").toString().toLowerCase().includes(this.ageFilterValue.toString().toLowerCase()))
                ) && 
                (
                  (this.statusFilterValue || "").length == 0 ||
                  ((this.statusFilterValue || "").length > 0 && this.statusFilterValue.some(items => (item.waiverStatus || "").toLowerCase() === items.toLowerCase()))
                ) && 
                (
                  (this.signedByFilterValue || "").length == 0 ||
                  ((this.signedByFilterValue || "").length > 0 && (item.name || "").toLowerCase().includes(this.signedByFilterValue.toLowerCase()))
                )
              )
            });
          }
        } else {
          if((this.filterValue || "").length > 0) {
            results = results.filter((item) => {
              const firstNameCond = (item.participantName || "").toString().toLowerCase().match((this.filterValue || "").toString().toLowerCase());
              const lastNameCond = (item.participantLastname || "").toString().toLowerCase().match((this.filterValue || "").toString().toLowerCase());
              const dateSignedCond = (item.isAgreedChk || "").toString().toLowerCase().match((this.filterValue || "").toString().toLowerCase());
              const ageCond = (item.age || "").toString().toLowerCase().match((this.filterValue || "").toString().toLowerCase());
              const statusCond = (item.waiverStatus || "").toString().toLowerCase().match((this.filterValue || "").toString().toLowerCase());
              const signedByCond = (item.name || "").toString().toLowerCase().match((this.filterValue || "").toString().toLowerCase());
              
              return !!this.filterValue && (
                    (!!firstNameCond && firstNameCond.length > 0) || 
                    (!!lastNameCond && lastNameCond.length > 0) || 
                    (!!dateSignedCond && dateSignedCond.length > 0) || 
                    (!!signedByCond && signedByCond.length > 0) || 
                    (!!ageCond && ageCond.length > 0) || 
                    (!!statusCond && statusCond.length > 0)
                )
            });
          }
        }
      }
      if (this.sortBy) {
        const key = this.sortBy;
        const desc = !!this.sortDesc;
        results = results.slice().sort((a, b) => {
          let av = a[key];
          let bv = b[key];
          if (key === 'isAgreedChk') {
            av = av ? new Date(av).getTime() : 0;
            bv = bv ? new Date(bv).getTime() : 0;
          } else if (key === 'age') {
            av = parseInt(av, 10); bv = parseInt(bv, 10);
            if (isNaN(av)) av = -1;
            if (isNaN(bv)) bv = -1;
          } else {
            av = (av == null ? '' : String(av)).toLowerCase();
            bv = (bv == null ? '' : String(bv)).toLowerCase();
          }
          if (av < bv) return desc ? 1 : -1;
          if (av > bv) return desc ? -1 : 1;
          return 0;
        });
      }
      return results;
    },
    currentItem(){
      if(!this.ewsId) return '';

      return this.filteredItems.find(item => item.ewsId === this.ewsId);
    },
    emailWaiverConfirmationMessage() {
      if (!this.emailWaiverItem) return "";
      return this.$t("waiver_signed.email_confirmation_message", {
        name: `${this.emailWaiverItem.signatoryName || ""} ${this.emailWaiverItem.signatoryLastname || ""}`.trim(),
        email: this.emailWaiverItem.signatoryEmail || ""
      });
    },
    minorAccountManagers() {
      return this.emailWaiverItem && this.emailWaiverItem.accountManagers ? this.emailWaiverItem.accountManagers : [];
    },
    selectedAccountManager() {
      return this.minorAccountManagers.find(manager => parseInt(manager.id, 10) === parseInt(this.selectedAccountManagerId, 10));
    },
    minorEmailWaiverConfirmationMessage() {
      if (!this.selectedAccountManager) return "";
      return this.$t("waiver_signed.email_confirmation_message", {
        name: `${this.selectedAccountManager.firstName || ""} ${this.selectedAccountManager.lastName || ""}`.trim(),
        email: this.selectedAccountManager.emailAddress || ""
      });
    }
  },
  created: function() {
    this.buttonColor = process.env.VUE_APP_BUTTON_COLOR;
    this.getUser();
  },
  watch: {
    userCurrent(val) {
      if(val) {
        this.getEvents(val);
      }
    },
    windowWidth(val) {
        if(val < 600) {
            this.firstNameFilterValue = this.lastNameFilterValue = this.dateSignedFilterValue = this.ageFilterValue = this.statusFilterValue = this.signedByFilterValue = "";
        } else {
            this.filterValue = '';
        }
    },
  },
  mounted() {
    const parent = this;
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        parent.windowWidth = window.innerWidth;
      });
    })
  }
}
</script>

<style>
.btnCE{
  color:#fff !important;
}
#cloneEvents .v-data-table{
  margin: 0;
}
#cloneEvents .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
  font-size: 12px;
  padding: 5px;
}
#cloneEvents .v-data-table > .v-data-table__wrapper > table > thead > tr > th{
  padding: 5px;
}
.custFilter {
  background: var(--v-lighten-base) !important;
}
.filter .v-input {
  font-size: 14px;
}
.filter > .v-input__control {
  background-color: #fff;
}
.filter > .v-input__control > .v-input__slot {
  min-height: 32px !important;
}
.filter .v-label {
    top: 7px !important;
}
.icon-link:focus, .icon-link:hover {
  outline: none;
  text-decoration: none;
}

.v-data-table {
 margin: 0 !important;
}

.selectSeries .v-text-field__details, .selectSeries .v-messages {
  display: none;
}
.selectSeries.v-input {
    font-size: 14px;
}
@media (max-width: 960px) {
  #waiverSigned{
        margin: 0;
  }
}
.headTable tr:last-child {
    background: white !important;
}
.headTable tr:first-child th:hover {
    color: var(-v--primary-base) !important;
}
@media (min-width: 600px) {
    .contentRespTableFilter .v-data-table-header, .contentRespTableFilter .headTableMobile {
        display: none;
    }
    .contentRespTableFilter {
      overflow-x: auto;
    }
    .contentRespTableFilter .v-data-table {
      min-width: 1100px;
      padding-right: 10px !important;
    }
}
@media (max-width: 599px) {
  .contentRespTableFilter .headTable, .contentRespTableFilter .v-data-table-header-mobile {
        display: none;
  }
}
.classFilter .v-text-field__details {
  display: none;
}
.classFilter .v-input__slot {
  margin-bottom: 0px !important;
}
</style>
